import { render, staticRenderFns } from "./kundenliste.vue?vue&type=template&id=60373a02&scoped=true&"
import script from "./kundenliste.vue?vue&type=script&lang=js&"
export * from "./kundenliste.vue?vue&type=script&lang=js&"
import style0 from "./kundenliste.vue?vue&type=style&index=0&id=60373a02&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60373a02",
  null
  
)

export default component.exports